export type PillTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface StatusPillProps {
  tone: PillTone;
  label: string;
  title?: string;
  className?: string;
}

/** Compact status indicator — monochrome dot + solid tone (AA contrast). */
export function StatusPill({ tone, label, title, className }: StatusPillProps) {
  return (
    <span
      className={['u-pill', `u-pill--${tone}`, className].filter(Boolean).join(' ')}
      title={title}
      data-tone={tone}
    >
      {label}
    </span>
  );
}

export interface BadgeProps extends Omit<StatusPillProps, 'tone'> {
  tone?: PillTone;
}

export function Badge({ tone = 'neutral', ...rest }: BadgeProps) {
  return <StatusPill tone={tone} {...rest} />;
}

/** Map URoute job statuses to pill tones (single source for web + pwa). */
export const JOB_STATUS_TONE: Record<string, PillTone> = {
  received: 'neutral',
  unallocated: 'warning',
  allocated: 'info',
  accepted: 'info',
  in_progress: 'info',
  exception: 'danger',
  completed: 'success',
  invoice_draft: 'neutral',
  invoice_sent: 'info',
  payment_completed: 'success',
  rejected: 'danger',
  cancelled: 'neutral',
  void: 'danger',
};

export interface JobStatusPillProps {
  status: string;
  label: string;
  title?: string;
}

export function JobStatusPill({ status, label, title }: JobStatusPillProps) {
  return <StatusPill tone={JOB_STATUS_TONE[status] ?? 'neutral'} label={label} title={title} />;
}
